"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const storm_ui_1 = require("@amzn/storm-ui");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const regionUtils_1 = require("../../../utils/regionUtils");
const TranslationProvider_1 = require("../TranslationProvider/TranslationProvider");
// This style is copied from the AACMarketplaceSelectorUI
// https://code.amazon.com/packages/AACMarketplaceSelectorUI/trees/mainline
const StyledButton = (0, styled_components_1.default)(storm_ui_1.Button) `
  background-color: ${({ theme }) => theme.palette.gray[700]};

  &&& {
    color: ${({ theme }) => theme.palette.white};
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.gray[800]};
    box-shadow: 0 1px 3px rgba(35, 47, 63, 0.8);
  }
`;
const RegionSwitcherSelectorTrigger = react_1.default.forwardRef(({ onClick, currentRegionId }, ref) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const regionLabel = translate('region');
    const region = translate((0, regionUtils_1.getRegionLabel)(currentRegionId));
    const buttonLabel = regionLabel + ': ' + region;
    return ((0, jsx_runtime_1.jsx)(StyledButton, { onClick: onClick, buttonRef: ref, role: 'button', children: buttonLabel }));
});
exports.default = RegionSwitcherSelectorTrigger;
//# sourceMappingURL=RegionSwitcherSelectorTrigger.js.map